import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import {useSnackbar} from 'notistack';
import React, {useContext, useEffect, useState} from 'react';
import {withRouter} from 'react-router-dom';
import {AppContext} from '../../../components/shared/context';
import DesativarPerfil from '../../../components/usuario/desativarPerfil';
import UsuarioForm from '../../../components/usuario/usuarioForm';
import TipoPerfil from '../../../constants/tipoPerfil';
import {alteraUsuario, getById} from '../../../services/usuario/UsuarioService';
import useStyles from './styles';

const EditarUsuario = (props) => {
  const classes = useStyles();
  const { keycloak , role } = useContext(AppContext);
  const sub = keycloak.tokenParsed.sub;
  const [initialValue, setInitialValue] = useState(null);
  const { history } = props;
  const id = props.match.params.id;
  const { enqueueSnackbar } = useSnackbar();
  const [podeEditar, setPodeEditar] = useState(true);
  const [listaPerfis, setListaPerfis] = useState([]);

  useEffect(() => {
    getById(id).then((response) => {
      if (response) {
        const { data } = response;
        setListaPerfis(data.perfis)
        setInitialValue(data)
        setPodeEditar((TipoPerfil.EQUIPE_TECNICA.is(role)) || sub === data.sub);
      }else {
        setPodeEditar(false);
      }
    })
  }, [])


  const handleSubmit = async (form, tipoPerfil) => {

    let response;

    response = await alteraUsuario(id, form);

    /*    switch (tipoPerfil) {
          case TipoPerfil.CONSELHEIRO.id:
            response = await alterarConselheiro(id, form);
            break;
          case TipoPerfil.EQUIPE_TECNICA.id:
            response = await alterarEquipeTecnica(id, form);
            break;
          case TipoPerfil.INTERLOCUTOR.id:
            response = await alterarInterlocutor(id, form);
            break;
          default:
            break;
        }*/

    if (response && response.status === 200) {
      enqueueSnackbar("Operação realizada com sucesso!", { variant: 'success'})
      history.push(`/usuario/${id}`);
      window.location.reload();
    }
  }

  if (!podeEditar) {
    return (<p>Você não tem permissão para essa página ou o serviço está indisponivel!</p>)
  }

  return (
    <div className={classes.jumbotron}>
      <div className={classes.barraAzul}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '20px 50px 0px 49px' }}>
          <Button
            style={{ color: '#fff' }}
            startIcon={<ArrowBackIosIcon />}
            onClick={() => history.goBack()}>
            Voltar
          </Button>
        </div>
      </div>
      <Container maxWidth="sm">
        <UsuarioForm tipo="editar" listaPerfis={listaPerfis} initialValue={initialValue} onSubmit={handleSubmit} labelBotao="Salvar alterações" />
      </Container>
    </div>
  )
}

export default withRouter(EditarUsuario);
